import { render, staticRenderFns } from "./vpd-md-viewer.vue?vue&type=template&id=2f3449a8&"
import script from "./vpd-md-viewer.vue?vue&type=script&lang=js&"
export * from "./vpd-md-viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports